<template>
  <div class="IpoPage">
    <van-image class="mainHeader"  fit="contain" :src="require('../assets/IpoPagebg.png')" />
    <van-image class="mainH3"  fit="contain" :src="require('../assets/mainHeader.png')" />
    <van-image class="toothBG"  fit="contain" :src="require('../assets/toothBG.png')" />
    <div class="goGetHeaderBody">
      <van-button class="goGetHeaderBtn" type="info" @click="goGetHeader"></van-button>
    </div>
    <!-- <van-image class="footerTop" fit="contain" :src="require('../assets/footerTop.png')" /> -->
    <van-image class="footerBottom" fit="contain" :src="require('../assets/footerBottom.png')" />
  </div>
</template>

<script>
import Vue from 'vue';
import { Button, Toast, Image } from 'vant';
export default {
  name: 'IpoPage',
  data() {
    return {
    };
  },
  mounted: function () {
    WXconfig.prototype.updateAppMessageShareData(); // 分享给盆友
    WXconfig.prototype.onMenuShareAppMessage(); // 分享给盆友
    WXconfig.prototype.onMenuShareTimeline();  // 分享到盆友圈
    WXconfig.prototype.updateTimelineShareData();  // 分享到盆友圈
  },
  methods:{
    // 去换头像页面
    goGetHeader:function(){
      this.$router.push({
        path: '/getHeader',
      })
    }
  }
};
Vue.use(Button);
Vue.use(Image);
Vue.use(Toast);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.IpoPage{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;;
  align-items: center;
  flex-direction: column;
  background: url("../assets/IpoPage.png");
  background-size: cover;
  .mainHeader{
    width: 80%;
  }
  .mainH3{
    width: 80%;
  }
  .toothBG{
    margin-top: 10%;
    width:40%;
  }
  .goGetHeaderBody{
    margin-top: 13%;
    text-align: center;
    .goGetHeaderBtn{
      width: 200px;
      background:url("../assets/goGetHeaderBtn.png") no-repeat;
      background-clip: border-box;
      background-size:contain;
      border: 0;
    }
  }
  .footerTop{
    width: 70%;
    margin-top: 15%;
  }
  .footerBottom{
    width: 50%;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/IpoPage.vue